import { atom } from 'recoil'
import { IProjectRole } from '../../projectRoles.types'

interface IProjectRolesTableAtomState {
  items: IProjectRole[]
}
const projectRolesTableAtom = atom<IProjectRolesTableAtomState>({
  key: 'admin/tables/project-roles',
  default: { items: [] },
})
export default projectRolesTableAtom
